import ArrowNav from "@/components/ArrowNav";
import Sitemap from "@/components/Sitemap";
import OfferCard from "@/components/OfferCard";
import { Button } from "@/components/ui/button";
import TileCard from "@/components/TileCard";
import ModelCard from "@/components/ModelCard";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import Award from "@/components/Award";
import HomeFilterBar from "@/features/HomeFilterBar";
import AppHeader from "@/layouts/AppHeader";
import { getBanners, getHomepageContent } from "@/lib/service";
import { BannerProps, HomepageContent } from "@/lib/type";
import WhatsAppFab from "@/components/WhatsAppFab";
import { AppFooter } from "@/layouts/AppFooter";
import { useNavigate } from "react-router-dom";
import { useRegion } from "@/context/RegionContext";

function Home() {
  const [mobileShow, setMobileShow] = useState(false);
  const [banners, setBanners] = useState<BannerProps[]>([]);
  const navigate = useNavigate();
  const { region } = useRegion();
  const [homepageContent, setHomepageContent] = useState<HomepageContent>(
    region.homepageContent
  );
  const resolveFrontendUrl = (url: string) =>
    /^https?:\/\//i.test(url)
      ? url
      : `${region.productionUrl}${url.startsWith("/") ? url : `/${url}`}`;
  const handleNavigate = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  useEffect(() => {
    setHomepageContent(region.homepageContent);
    getBannerList();
    getHomepageContent(region.homepageContent).then(setHomepageContent);
  }, [region]);

  const getBannerList = async () => {
    const bannerList = await getBanners("all");

    setBanners(bannerList.data);
  };

  return (
    <>

    <WhatsAppFab/>
      {/* Header */}
      <div className="bg-black bg-[url('/home/background.webp')] bg-[length:550px_250px] bg-no-repeat bg-[center_top_0rem]">
        <AppHeader className="pt-4 px-4 md:px-32" />
        <div className="px-4 md:px-32">
          <div className="md:w-2/5 text-white font-bold md:text-3xl text-xl mt-4 md:mb-10 mb-4">
            Looking for a vehicle? You’re at the right place.
          </div>
          {/* Hide this client request */}
          {/* <div className="bg-white/30 rounded-md p-2 flex flex-col space-y-2 md:space-y-0 md:grid md:grid-cols-7 md:items-center">
            <div className="rounded-md bg-[#e70940] text-white font-bold text-center mx-2 text-xs md:py-[0.25rem] md:px-2 px-4 py-2 md:w-[90%] w-fit">
              Up to {banners[4]?.discount_percentage.replace(/\.00$/,'')}% 
            </div>
            <span className="text-white flex flex-row md:col-span-5 ml-2">
              <p className="font-bold"> {banners[4]?.highlight_text}</p>
            </span>
            <a className="text-white font-bold md:ml-0 ml-2" href={banners[4]?.redirect_url}  target="_blank">
              More details {">"}
            </a>
          </div> */}
          <HomeFilterBar />
          <div className="grid grid-rows-4 space-y-4 md:space-y-0 md:grid-cols-4 py-6">
          <ArrowNav title="My bookings" onClick={() => { navigate(`/search-booking`)}} />
          <ArrowNav title="Members' Discount" onClick={() => {  handleNavigate(`https://privilege.europcar.com/join/`);}} />
            <ArrowNav title="See all our deals" onClick={() => {  navigate(`/pages/top-deals`);}} />
            <ArrowNav title="Go to Europcar Business" onClick={() => {   navigate(`/pages/corporate-car-leasing/`);}} />
          </div>
        </div>
      </div>
      {/* Offer */}
      <div className="md:mx-32 mx-4 my-12">
        <p className="font-bold text-xl mb-8 md:mx-0 mx-4">
          Today's car rental offers
        </p>
        <div className="grid grid-row-4 md:grid-cols-4 gap-5 mb-6">
          {banners.slice(0, 4).map((e) => (
            <OfferCard
              key={`banner-${e.id}`}
              bgImage={e.image_path || ''}
              title={e.main_title}
              descTop={e.subtitle}
              url={e.redirect_url}
              isRedirect={e.open_in_new_tab == 1}
            />
          ))}
        </div>
        <div className="flex md:flex-row flex-col md:space-x-6 mt-2 md:mt-0">
          <img
            src={homepageContent.leasing.imageUrl}
            className="md:w-3/5 w-full rounded-sm"
          />
          <div className="md:w-2/5 md:my-auto mt-2 space-y-2 md:justify-items-start justify-items-center">
            <p className="font-bold text-gray-500 text-sm">
              {homepageContent.leasing.eyebrow}
            </p>
            <p className="font-bold text-xl">{homepageContent.leasing.title}</p>
            <p className="text-gray-400 md:text-start text-center">
              {homepageContent.leasing.description}
            </p>
            <Button className="bg-yellow-400 text-black font-medium py-6">
              <a href={resolveFrontendUrl(homepageContent.leasing.buttonUrl)}>
                {homepageContent.leasing.buttonText}
              </a>
            </Button>
          </div>
        </div>
      </div>
      {/* Fleet */}
      <section className="bg-[#f7f7f7] pt-8 pb-4 mb-12">
        <div className="md:px-32 px-4">
          <p className="font-bold text-xl">{homepageContent.fleet.title}</p>
          <p className="text-gray-400">
            {homepageContent.fleet.description}
          </p>
        </div>
        <div className="md:mx-52 mx-4 mt-8 grid md:grid-cols-3 md:gap-5">
          {homepageContent.fleet.cards.map((card, index) => (
            <ModelCard
              key={`${region.code}-fleet-card-${index}`}
              title={card.title}
              desc={card.description}
              image={card.imageUrl}
              link={resolveFrontendUrl(card.url)}
              buttonText={card.buttonText}
            />
          ))}
        </div>
      </section>
      {/* Discover */}
      <div className="md:mx-32 mx-4 grid grid-row-3 mt-10 md:mt-0 md:grid-cols-3 gap-4 mb-6">
        <TileCard
          image="/icon/discount.svg"
          title="Discounts and Benefits"
          desc="Become a Privilege Member."
          buttonDesc="Discover"
          link="https://privilege.europcar.com/join/"
        />
        <TileCard
          image="/icon/periodic.svg"
          title="Flexible Rental Period"
          desc="Whether you need daily, monthly or yearly choose a length."
          buttonDesc="Book now"
          link={`${region.productionUrl}/pages/corporate-car-leasing`}
        />
        <TileCard
          image="/icon/icone-online-checkin.svg"
          title="Best Price Guaranteed"
          desc="Get the best price when you book direct."
          buttonDesc="Read more"
          link={`${region.productionUrl}/pages/top-deals`}
        />
      </div>
      {/* Car Rental Location */}
      <div className="bg-[#f7f7f7] md:px-32 px-4 py-8 flex md:flex-row flex-col">
        <div className="mr-12">
          <img src="/icon/globe.svg" />
          <p className="font-bold text-2xl">
            {region.homepageHeading}
          </p>
          <p className="text-gray-500 text-xl">
            <span className="text-green-600">3835</span> Europcar locations in
            over <span className="text-green-600">140</span> countries
          </p>
        </div>
        <div className="flex flex-col">
          <div className="md:grid md:grid-cols-4 md:gap-4 space-y-4 md:space-y-0">
            <Sitemap
              title="Top Locations"
              contentList={region.topLocations.map(loc => ({
                title: loc.title,
                url: `${region.productionUrl}${loc.url}`,
              }))}
            />
            <Sitemap
              title={`Top Cities in ${region.countryName}`}
              contentList={region.topCities.map(city => ({
                title: city.title,
                url: `${region.productionUrl}${city.url}`,
              }))}
            />
            <Sitemap
              title="Top Countries"
              contentList={region.topCountries.map(country => ({
                title: country.title,
                url: `${region.productionUrl}${country.url}`,
              }))}
            />
          </div>
          <a href="https://www.europcar.com/en/locations" target="_blank" className="hover:underline text-green-600 font-bold mt-4 md:mt-0">
            All countries
          </a>
        </div>
      </div>
      {/* FAQ */}
      {/* <div className="md:mx-48 mx-4 py-16 flex flex-row justify-between font-bold text-xl">
        Book a car rental with Europcar
        <span>+</span>
      </div> */}
      <div className="h-[1px] w-full bg-gray-100"></div>
      {/* Partner */}
      <div className="md:mx-32 mx-4 my-8">
        <div className="flex flex-row font-bold text-2xl justify-between">
          <span>Our alliances & partners</span>
          <span
            className="md:hidden block"
            onClick={() => setMobileShow(!mobileShow)}
          >
            {mobileShow ? "-" : "+"}
          </span>
        </div>
        {mobileShow ? (
          <div className="grid grid-cols-2 md:grid-cols-3 items-center mx-4 my-6 mx:m-0">
            {region.partnerLinks.map((partner, i) => (
              <a key={`partner-m-${i}`} href={partner.href} target="_blank"><img src={partner.imgSrc} className={i === 1 ? "md:place-self-center" : i === 2 ? "md:place-self-end" : ""} /></a>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 items-center mx-4 my-6 mx:m-0">
            {region.partnerLinks.map((partner, i) => (
              <a key={`partner-${i}`} href={partner.href} target="_blank"><img src={partner.imgSrc} className={i === 1 ? "md:place-self-center" : i === 2 ? "md:place-self-end" : ""} /></a>
            ))}
        </div>
        )}
        <div className=" flex flex-col mt-2">
        <a href={`${region.productionUrl}/pages/partners`} target="_blank" className="hover:underline cursor-pointer text-sm text-green-600 font-bold">
          More partners
        </a>
        <a href={`${region.productionUrl}/pages/partners`} target="_blank" className="hover:underline cursor-pointer text-sm text-green-600 font-bold">
        Join our affiliate program
        </a>
        </div>

      </div>
   
   <AppFooter/>
    </>
  );
}

export default Home;
